import MainLayout from "../../../../components/mainLayout";
import { PAGES } from "../../../../routes";
import audio from "../../../../assets/audio/45.mp3"
export default function P1() {
    return (
        <MainLayout
            title="Karczma Pani Jasińskiej"
            question="Czy chcesz przyjąć ofertę i nauczyć się fachu gęsiarstwa?"
            audio={audio}
            answers={{
                ans1: "Tak, postanowione! Zostanę gęsiarzem!",
                ans2: "Nie, to chyba nie jest praca dla mnie.",
            }}
            links={{
                link1: PAGES.p72,
                link2: PAGES.p73,
            }}
            content={
                <div>
                    <p>
                        Perlisty dźwięk dzwonka na drzwiach ogłasza twoje wejście do knajpy pani Jasińskiej. Nikt cię jednak nie zauważa, ludzie tłoczą się przy stołach, kilka osób gra nawet w bilard. Zdaje się, że szczęśliwiec z targu końskiego postawił już obiecaną kolejkę. Przy oknie widzisz Tornaua i Emila.
                    </p>
                    <ul>
                        <li>
                            Słuchaj, a może chcesz się przyuczyć, jak robić przy gęsiach? – pyta cię od razu Emil. – Pan Tornau to wymyślił. Może cię nauczyć!
                        </li>
                    </ul>
                    <p>
                        Stary Tornau potwierdza słowa Emila kiwnięciem głowy i spogląda na ciebie z zainteresowaniem, przerzucając między palcami włosy swojej długiej brody.
                    </p>
                </div>
            }
        />

    );
}